module.exports = __webpack_public_path__ + "static/img/animat-checkmark.c751c36f.gif";